/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { IdpGroup } from '../models/IdpGroup';

export class CreateIdpGroupResponse {
  'group': IdpGroup;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "group",
      "baseName": "group",
      "type": "IdpGroup",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return CreateIdpGroupResponse.attributeTypeMap;
  }

  public constructor() {
  }
}

